<template>
  <div class="w-full">
    <div class="font-semibold text-2xl mb-5">Riwayat</div>
    <div class="flex flex-col">
      <global-wrapper :loading="false" :empty="false">
        <AbsensiRiwayatItem v-for="(at,i) in attendances" :key="i" :attendance="at" />
      </global-wrapper>
    </div>
  </div>
</template>

<script>
import AbsensiRiwayatItem from "./AbsensiRiwayatItem.vue";
import {digofHttp} from '@/axios'

export default {
  components: {
    AbsensiRiwayatItem
  },
  data(){
    return {
      attendances: []
    }
  },
  mounted() {
    this.fetchData()
    this.$globalBus.$on('updateAttendance', () => {
      this.fetchData()
    })
  },
  methods: {
    fetchData(){
      digofHttp.get(`attendance/list`)
        .then(r => {
          this.attendances = r.data.data.attendances
        })
    }
  }
};
</script>
